import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import PhoneLogin from '@/components/PhoneLogin'
import My from '@/components/My'
import questionnaire from '@/components/Questionnaire'
import suggestion from '@/components/Suggestion'
import suggestion_next from '@/components/SuggestionNext'
import feedback from '@/components/Feedback'
import purchase_service from '@/components/PurchaseService'
import confirmOrder from '@/components/ConfirmOrder'
import pay from '@/components/Pay'
import payresult from '@/components/PayResult'

import orderList from '@/components/OrderList'
import OrderDetail from '@/components/OrderDetail'
import aboutUs from '@/components/AboutUs'
import Article from '@/components/Article'
import Download from '@/components/Download'
import QuestionsPage from '@/components/QuestionsPage'
import Ask from '@/components/Ask'
import ArticlePage from '@/components/ArticlePage'
import diggme from '@/static/Diggme'
import Team from '@/components/Team'
import FirstBindMobile from '@/components/FirstBindMobile'
import Service from '@/components/Service'
import PrimaryService from '@/components/PrimaryService'
import EngineerList from '@/components/EngineerList'
import Login from '@/components/Login'
import BandMobile from '@/components/BandMobile'
import ConfirmV3 from '@/components/ConfirmOrderV3'
import OrderRemark from '@/components/OrderRemark'
import Coupon from '@/components/Coupon'
import Message from '@/components/Message'
import Engineer from '@/components/Engineer'
import Evaluation from '@/components/Evaluation'
import ChangeMobile from '@/components/ChangeMobile'
import OrderHistory from '@/components/OrderHistory'
import ServiceInfo from '@/components/ServiceInfo'
import Consult from "@/components/Consult"
import ConsultDetail from "@/components/ConsultDetail"
import Logout from "@/static/guoshixiong/Logout"
import Agreement from '@/static/guoshixiong/Agreement'
import Privacy from '@/static/guoshixiong/Privacy'

import Logout_mj01 from "@/static/majia01/Logout"
import Agreement_mj01 from '@/static/majia01/Agreement'
import Privacy_mj01 from '@/static/majia01/Privacy'
import Logout_mj02 from "@/static/majia02/Logout"
import Agreement_mj02 from '@/static/majia02/Agreement'
import Privacy_mj02 from '@/static/majia02/Privacy'
import Logout_mj03 from "@/static/majia03/Logout"
import Agreement_mj03 from '@/static/majia03/Agreement'
import Privacy_mj03 from '@/static/majia03/Privacy'
import Layout from '@/components/Layout'

Vue.use(Router)

var router = new Router({
    mode: 'history',
    routes: [
        {
            path:'/',
            name: '/',
            component: Layout,
            children: [
                {
                    path: '/home',
                    name: 'index',
                    component: Home,
                },
                {
                    path: '/phoneLogin',
                    name: 'phoneLogin',
                    component: PhoneLogin,
                    beforeEnter: (to, from, next) => {
                        if (from.name) {
                            sessionStorage.name = from.name;
                        }
                        if (from.name == 'questionnaire' || from.name == 'my') {
                            var login_first = localStorage.login_first
                            if (login_first) {
                                login_first = parseInt(login_first) + 1;
                                localStorage.login_first = login_first;
                                if (login_first == 2) {
                                    router.push({ name: "home" })
                                    localStorage.removeItem("login_first");
                                }
                            } else {
                                localStorage.login_first = 1;
                            }
                        } else {
                            localStorage.removeItem("login_first");
                        }
                        next(true);
                    }
                },
                {
                    path: '/my',
                    name: 'my',
                    component: My,
                },
                {
                    path: '/questionnaire/:gid',
                    name: 'questionnaire',
                    component: questionnaire,
        
                },
                {
                    path: '/suggestion',
                    name: 'suggestion',
                    component: suggestion
                },
                {
                    path: '/suggestion_next',
                    name: 'suggestion_next',
                    component: suggestion_next
                },
                {
                    path: '/feedback',
                    name: 'feedback',
                    component: feedback
                },
                {
                    path: '/purchaseService',
                    name: 'purchase_service',
                    component: purchase_service
                },
                {
                    path: '/diggme',
                    name: 'diggme',
                    component: diggme
                },
                {
                    path: '/confirmOrder',
                    name: 'confirmOrder',
                    component: confirmOrder
                },
                {
                    path: '/pay',
                    name: 'pay',
                    component: pay
                },
                {
                    path: '/payResult',
                    name: 'payresult',
                    component: payresult
                },
                {
                    path: '/orderList',
                    name: 'orderList',
                    component: orderList
                },
                {
                    path: '/orderDetail',
                    name: 'orderDetail',
                    component: OrderDetail
                },
                {
                    path: '/aboutus',
                    name: 'aboutus',
                    component: aboutUs
                },
                {
                    path: '/article',
                    name: 'article',
                    component: Article,
                },
                {
                    path: '/download',
                    name: 'download',
                    component: Download,
                },
                {
                    path: '/questionspage',
                    name: 'questionspage',
                    component: QuestionsPage,
                }, {
                    path: '/ask',
                    name: 'ask',
                    component: Ask,
                },
                {
                    path: '/articlepage',
                    name: 'articlepage',
                    component: ArticlePage
                },
                {
                    path: '/team',
                    name: 'team',
                    component: Team
                },
                {
                    path: '/firstBindMobile',
                    name: 'firstBindMobile',
                    component: FirstBindMobile
                },
                {
                    path: '/service',
                    name: 'service',
                    component: Service
                },
                {
                    path: '/primary',
                    name: 'primary',
                    component: PrimaryService
                },
                {
                    path: '/engineerList',
                    name: 'engineerList',
                    component: EngineerList
                },
                {
                    path: '/login',
                    name: 'login',
                    component: Login
                },
                {
                    path: '/bandMobile',
                    name: 'bandMobile',
                    component: BandMobile
                },
                {
                    path: '/confirmV3',
                    name: 'confirmV3',
                    component: ConfirmV3
                },
                {
                    path: '/orderRemark',
                    name: 'orderRemark',
                    component: OrderRemark
                },
                {
                    path: '/coupon',
                    name: 'coupon',
                    component: Coupon
                },
                {
                    path: '/message',
                    name: 'message',
                    component: Message
                },
                {
                    path: '/engineer',
                    name: 'engineer',
                    component: Engineer
                },
                {
                    path: '/evaluation',
                    name: 'evaluation',
                    component: Evaluation
                },
                {
                    path: '/changeMobile',
                    name: 'changeMobile',
                    component: ChangeMobile
                },
                {
                    path: '/orderHistory',
                    name: 'orderHistory',
                    component: OrderHistory
                },
                {
                    path: '/serviceInfo',
                    name: 'serviceInfo',
                    component: ServiceInfo
                },
                //咨询
                {
                  path: '/consult',
                  name: 'consult',
                  component: Consult
                },
                {
                  path: '/consult/:id',
                  name: 'consultDetail',
                  component: ConsultDetail
                },
                {
                    path: '/logout',
                    name: 'logout',
                    component: Logout
                },
                {
                    path: '/agreement',
                    name: 'agreement',
                    component: Agreement
                },
                {
                    path: '/privacy',
                    name: 'privacy',
                    component: Privacy
                },
                {
                    path: '/logout_mj01',
                    name: 'logout_mj01',
                    component: Logout_mj01
                },
                {
                    path: '/agreement_mj01',
                    name: 'agreement_mj01',
                    component: Agreement_mj01
                },
                {
                    path: '/privacy_mj01',
                    name: 'privacy_mj01',
                    component: Privacy_mj01
                },
                {
                    path: '/logout_mj02',
                    name: 'logout_mj02',
                    component: Logout_mj02
                },
                {
                    path: '/agreement_mj02',
                    name: 'agreement_mj02',
                    component: Agreement_mj02
                },
                {
                    path: '/privacy_mj02',
                    name: 'privacy_mj02',
                    component: Privacy_mj02
                },
                {
                    path: '/logout_mj03',
                    name: 'logout_mj03',
                    component: Logout_mj03
                },
                {
                    path: '/agreement_mj03',
                    name: 'agreement_mj03',
                    component: Agreement_mj03
                },
                {
                    path: '/privacy_mj03',
                    name: 'privacy_mj03',
                    component: Privacy_mj03
                },
                {
                    path: '*',
                    redirect: { name: 'index' }
                }
            ]
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})

router.beforeEach((to, from, next) => {
    // 统计代码
    if (to.path) {
        _hmt.push(['_trackPageview', to.fullPath]);
    }
    setTimeout(function() {
        if (document.getElementById("dialogtips")) {
            document.body.removeChild(document.getElementById("dialogtips"));
        }
    })

    next();
});

router.afterEach((to, from, next) => {
    Vue.nextTick(() => {
        sa.quick("autoTrackSinglePage");
    });

});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js